import React from 'react';

interface AnticipationTimelineProps {
  currentMonth: number;
  onSelectMonth: (m: number) => void;
}

export const AnticipationTimeline: React.FC<AnticipationTimelineProps> = ({
  currentMonth,
  onSelectMonth
}) => {
  const meses = [
    { num: 1, nome: 'Jan', foco: 'Volta às Aulas & Clima', highlight: false },
    { num: 2, nome: 'Fev', foco: 'Carnaval & PIS/PASEP', highlight: false },
    { num: 3, nome: 'Mar', foco: 'Semana Consumidor', highlight: false },
    { num: 4, nome: 'Abr', foco: 'Páscoa & 13º INSS (1ªP)', highlight: true },
    { num: 5, nome: 'Mai', foco: 'Dia das Mães & IRPF (L1)', highlight: true },
    { num: 6, nome: 'Jun', foco: 'Namorados & IRPF (L2)', highlight: true },
    { num: 7, nome: 'Jul', foco: 'Férias & IRPF (L3)', highlight: true },
    { num: 8, nome: 'Ago', foco: 'Dia dos Pais & IRPF (L4)', highlight: false },
    { num: 9, nome: 'Set', foco: 'Semana Brasil & Casa', highlight: false },
    { num: 10, nome: 'Out', foco: 'Crianças & Rampa BF', highlight: true },
    { num: 11, nome: 'Nov', foco: 'BLACK FRIDAY (13º CLT)', highlight: true },
    { num: 12, nome: 'Dez', foco: 'Natal & Réveillon (13º)', highlight: true }
  ];

  return (
    <div style={{
      backgroundColor: 'var(--bg-1)',
      border: '1px solid var(--border-1)',
      borderRadius: 'var(--r-lg)',
      padding: '16px 20px',
      marginBottom: '24px',
      overflowX: 'auto'
    }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '12px', flexWrap: 'wrap', gap: '8px' }}>
        <span style={{ fontSize: 'var(--fs-xs)', fontWeight: 700, color: 'var(--text-3)', textTransform: 'uppercase', letterSpacing: '0.04em' }}>
          Ciclo Anual de Antecipação & 52 Semanas (Brasil)
        </span>
        <span style={{ fontSize: 'var(--fs-xs)', color: 'var(--nexus-brand)', fontWeight: 600 }}>
          Clique em qualquer mês para carregar o Planner
        </span>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(12, minmax(80px, 1fr))', gap: '6px' }}>
        {meses.map((m) => {
          const isSelected = m.num === currentMonth;
          return (
            <button
              key={m.num}
              onClick={() => onSelectMonth(m.num)}
              style={{
                backgroundColor: isSelected ? 'var(--nexus-brand)' : (m.highlight ? 'var(--nexus-brand-bg)' : 'var(--bg-2)'),
                border: `1px solid ${isSelected ? 'var(--nexus-brand-active)' : (m.highlight ? 'var(--nexus-brand)' : 'var(--border-1)')}`,
                borderRadius: 'var(--r-sm)',
                padding: '10px 6px',
                textAlign: 'center',
                cursor: 'pointer',
                transition: 'all 0.15s ease',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
                minHeight: '68px'
              }}
            >
              <div style={{
                fontSize: 'var(--fs-sm)',
                fontWeight: 800,
                color: isSelected ? 'var(--text-on-accent)' : 'var(--text-1)',
                marginBottom: '4px'
              }}>
                {m.nome}
              </div>
              <div style={{
                fontSize: 'var(--fs-xxs)',
                color: isSelected ? 'var(--text-on-accent)' : 'var(--text-3)',
                lineHeight: 1.2,
                fontWeight: isSelected ? 600 : 400
              }}>
                {m.foco}
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
};
